// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";

// const AnimatedNavbar = () => {
//   const [atTop, setAtTop] = useState(true);
//   const [portfolioOpen, setPortfolioOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setAtTop(window.pageYOffset <= 50);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Animation variants
//   const dropdownVariants = {
//     open: {
//       transition: {
//         staggerChildren: 0.1,
//       },
//     },
//     closed: {},
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: -10 },
//     visible: { opacity: 1, y: 0 },
//   };

//   return (
//     <motion.div
//       className="fixed top-0 left-0 w-full z-50"
//       initial={{ opacity: 0, y: -30 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.8, ease: "easeOut" }}
//     >
//       <div
//         className={`fixed z-50 shadow-xl w-full px-8 py-4 transition-all duration-1000 rounded-full mt-4 inset-x-0 mx-auto ease-in-out transform ${atTop
//           ? "max-w-4xl bg-white"
//           : "bg-white/10 backdrop-blur-md ring-1 ring-white/20 max-w-6xl"
//           }`}
//       >
//         <div className="flex flex-col w-full p-2 mx-auto md:items-center md:justify-between md:flex-row">
//           <div className="flex flex-row items-center justify-between w-full">
//             <span className="font-bold tracking-tighter uppercase text-black">
//               ✺ The Mk Solution
//             </span>

//             <button className="md:hidden focus:outline-none">
//               <svg
//                 className="w-6 h-6"
//                 fill="none"
//                 stroke="black"
//                 strokeWidth={2}
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   d="M4 6h16M4 12h16M4 18h16"
//                 />
//               </svg>
//             </button>
//           </div>

//           {/* Navigation */}
//           <nav className="hidden md:flex items-center space-x-10 mt-4 md:mt-0 lg:ml-auto relative">
//             {/* Home Link */}
//             <Link to="/" className="relative group">
//               <span className="text-sm font-medium text-black">Home</span>
//               <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#8B4AFA] group-hover:w-full transition-all duration-300" />
//               <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white/20 group-hover:w-full transition-all duration-500 delay-100" />
//             </Link>

//             {/* Portfolio Dropdown */}
//             <div
//               className="relative group"
//               onMouseEnter={() => setPortfolioOpen(true)}
//               onMouseLeave={() => setPortfolioOpen(false)}
//             >
//               <span className="text-sm font-medium cursor-pointer text-black">
//                 Portfolio
//               </span>
//               {/* <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#8B4AFA] group-hover:w-full transition-all duration-300" />
//               <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white/20 group-hover:w-full transition-all duration-500 delay-100" /> */}

//               {/* Dropdown Animated */}
//               <AnimatePresence>
//                 {portfolioOpen && (
//                   <motion.div
//                     className="absolute top-full mt-2 w-48 bg-white shadow-lg rounded-lg p-2 z-50"
//                     initial="closed"
//                     animate="open"
//                     exit="closed"
//                     variants={dropdownVariants}
//                   >
//                     {[
//                       { name: "AI Agents", to: "/portfolio/ai-agents" },
//                       { name: "Twillio IVRs", to: "/portfolio/twilio-ivrs" },
//                       { name: "Web Apps", to: "/portfolio/web-apps" },
//                       { name: "Mobile Apps", to: "/portfolio/mobile-apps" },
//                       { name: "A2P 10 Dlc Approval", to: "/portfolio/a2p-approval" },

//                     ].map((item) => (
//                       <motion.div
//                         key={item.to}
//                         variants={itemVariants}
//                         initial="hidden"
//                         animate="visible"
//                         exit="hidden"
//                         className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
//                       >
//                         <Link to={item.to}>{item.name}</Link>
//                       </motion.div>
//                     ))}
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>

//             {/* About */}
//             <Link to="/about" className="relative group">
//               <span className="text-sm font-medium text-black">About</span>
//               <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#8B4AFA] group-hover:w-full transition-all duration-300" />
//               <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white/20 group-hover:w-full transition-all duration-500 delay-100" />
//             </Link>

//             {/* Contact */}
//             <Link to="/contact" className="relative group">
//               <span className="text-sm font-medium text-black">Contact</span>
//               <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#8B4AFA] group-hover:w-full transition-all duration-300" />
//               <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white/20 group-hover:w-full transition-all duration-500 delay-100" />
//             </Link>
//           </nav>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// export default AnimatedNavbar;

import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  motion,
  AnimatePresence,
  MotionConfig,
  useScroll,
  useSpring,
} from "framer-motion";
import {
  FaChevronDown,
  FaChevronUp,
  FaExternalLinkAlt,
  FaTimes,
  FaRobot,
  FaPhoneAlt,
  FaGlobe,
  FaMobileAlt,
  FaCheckCircle,
  FaBolt,
} from "react-icons/fa";
import { SiOpenai, SiTwilio, SiReact, SiFlutter } from "react-icons/si";
import BrandButton from "./BrandButton";

// Reusable desktop nav item )
const DesktopNavItem = ({ to, label }) => (
  <NavLink
  to={to}
  className="relative group rounded-lg px-3 py-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4AFA]"
>
  {({ isActive }) => (
    <>
      <span
       className={`text-[14px] font-medium tracking-[-0.005em] transition-colors duration-200 ${
            isActive
              ? "text-[#8B4AFA]"
              : "text-slate-600 group-hover:text-violet-700"
          }`}
        >
          {label}
        </span>
        {isActive && (
          <motion.span
            layoutId="nav-underline"
            transition={{ type: "spring", stiffness: 380, damping: 30 }}
            className="absolute -bottom-px left-3 right-3 h-0.5 bg-[#8B4AFA] rounded-full"
          />
        )}
      </>
    )}
  </NavLink>
);

const AnimatedNavbar = () => {
  const [atTop, setAtTop] = useState(true);
  const [portfolioOpen, setPortfolioOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobilePortfolioOpen, setMobilePortfolioOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const location = useLocation();

  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  const isPortfolioActive = location.pathname.startsWith("/portfolio");

  useEffect(() => {
  const handleScroll = () => {
    const nextAtTop = window.pageYOffset <= 50;
    setAtTop((currentAtTop) =>
      currentAtTop === nextAtTop ? currentAtTop : nextAtTop
    );
  };
  handleScroll(); // sync state if the page loads already scrolled
  window.addEventListener("scroll", handleScroll, { passive: true });
  return () => window.removeEventListener("scroll", handleScroll);
}, []);
  // Close sidebar on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 
  useEffect(() => {
    setPortfolioOpen(false);
    setProductsOpen(false);
    setSidebarOpen(false);
  }, [location.pathname]);

  // Reset mobile accordions whenever the sidebar closes.
  useEffect(() => {
    if (!sidebarOpen) {
      setMobilePortfolioOpen(false);
      setMobileProductsOpen(false);
    }
  }, [sidebarOpen]);

  // Lock page scroll while the mobile sidebar is open, and close it with Escape.
  useEffect(() => {
    if (!sidebarOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setSidebarOpen(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [sidebarOpen]);

  // Animation variants
  const dropdownVariants = {
    open: { transition: { staggerChildren: 0.1 } },
    closed: {},
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0 },
  };

  const portfolioLinks = [
  { name: "AI Agents", to: "/portfolio/ai-agents", logo: "/logos/ai-bot.png", desc: "Chat and voice agents for your business" },
  { name: "Twilio IVRs", to: "/portfolio/twilio-ivrs", icon: SiTwilio, color: "#F22F46", desc: "Call flows and phone automation" },
  { name: "Web Apps", to: "/portfolio/web-apps", icon: SiReact, color: "#149ECA", desc: "Custom web platforms and dashboards" },
  { name: "Mobile Apps", to: "/portfolio/mobile-apps", logo: "/logos/mobile-app.png", desc: "iOS and Android applications" },
  { name: "A2P 10DLC Approval", to: "/portfolio/a2p-approval", logo: "/logos/tcr.jpeg", desc: "SMS brand and campaign registration" },
  { name: "GoHighLevel", to: "/portfolio/ghl-integration", logo: "/logos/gohighlevel-new.webp", desc: "CRM setup and automation" },
];

  const dropdownSurface =
    "rounded-2xl border border-slate-200/80 bg-white p-2 shadow-[0_1px_2px_rgba(15,23,42,0.05),0_16px_40px_-12px_rgba(15,23,42,0.18)]";

  const handleBlurClose = (setter) => (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) setter(false);
  };

  return (
    // MotionConfig: respects the visitor's "reduce motion" system setting for every animation below
    <MotionConfig reducedMotion="user">
      {/* Top Navbar (hidden when sidebar is open) */}
      {!sidebarOpen && (
        <motion.div
          className="fixed inset-x-0 top-2 z-50 px-4 sm:px-6 lg:px-8"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
        <motion.div
        initial={false}
        animate={{ maxWidth: atTop ? 1344 : 1200 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className={`relative mx-auto w-full overflow-visible rounded-2xl border bg-white transition-[border-color,box-shadow] duration-300 ease-out motion-reduce:transition-none ${
          atTop
            ? "border-[#8B4AFA]/10 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_10px_30px_-16px_rgba(76,29,149,0.22)]"
            : "border-[#8B4AFA]/20 shadow-[0_1px_2px_rgba(15,23,42,0.06),0_16px_40px_-14px_rgba(76,29,149,0.38)]"
        }`}
      >
            <div
              className={`flex items-stretch transition-[min-height] duration-300 ease-out motion-reduce:transition-none ${
              atTop ? "min-h-[80px]" : "min-h-[72px]"
              }`}
            >
      
             <div
                className={`flex items-center rounded-l-2xl bg-[#EFE9FF] pl-5 pr-12 sm:pl-8 lg:pr-16 transition-[padding] duration-300 ease-out motion-reduce:transition-none [clip-path:polygon(0_0,100%_0,calc(100%_-_28px)_100%,0_100%)] ${
                  atTop ? "py-3" : "py-2"
                }`}
              >
                <Link
                  to="/"
                  className="rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#8B4AFA]"
                >
                  <img
                    src="/website-logo1-309.webp"
                    alt="MK AI Technologies"
                    width="103"
                    height="56"
                    className={`h-14 w-auto origin-left transition-transform duration-300 ease-out motion-reduce:transition-none ${
                      atTop ? "scale-100" : "scale-[0.88]"
                    }`}
                  />
                </Link>
              </div>

              {/* Right side: hamburger on mobile, nav on desktop */}
              <div className="flex flex-1 items-center justify-end px-5 sm:px-8 lg:pr-8">
                <button
                  className="lg:hidden flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 bg-white transition-colors duration-200 hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4AFA]"
                  onClick={() => setSidebarOpen(true)}
                  aria-label="Open menu"
                  aria-expanded={sidebarOpen}
                  aria-controls="mobile-sidebar"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="#0f172a"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>

                {/* Desktop Nav */}
                <nav
                  aria-label="Main"
                  className="hidden lg:flex items-center gap-2 xl:gap-3 relative"
                >
                  <DesktopNavItem to="/" label="Home" />

                  {/* Portfolio Dropdown - hover trigger unchanged (mouse enter/leave) */}
                  <div
                    className="relative group"
                    onMouseEnter={() => setPortfolioOpen(true)}
                    onMouseLeave={() => setPortfolioOpen(false)}
                    onFocus={() => setPortfolioOpen(true)}
                    onBlur={handleBlurClose(setPortfolioOpen)}
                    onKeyDown={(e) => e.key === "Escape" && setPortfolioOpen(false)}
                  >
                   <button
                      className="flex items-center gap-1 rounded-lg px-3 py-1.5 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4AFA]"
                      aria-haspopup="true"
                      aria-expanded={portfolioOpen}
                    >
                      <span
                      className={`relative text-[14px] font-medium tracking-[-0.005em] transition-colors duration-200 ${
                          isPortfolioActive
                            ? "text-[#8B4AFA]"
                            : "text-slate-600 group-hover:text-violet-700"
                        }`}
                      >
                        Portfolio
                        {isPortfolioActive && (
                          <motion.span
                            layoutId="nav-underline"
                            transition={{ type: "spring", stiffness: 380, damping: 30 }}
                            className="absolute -bottom-[7px] left-0 w-full h-0.5 bg-[#8B4AFA] rounded-full"
                          />
                        )}
                      </span>

                      <FaChevronDown
                        size={9}
                        className={`transition-transform duration-200 ${
                          portfolioOpen
                            ? "rotate-180 text-[#8B4AFA]"
                            : "text-slate-400 group-hover:text-[#8B4AFA]"
                        }`}
                      />
                    </button>

                    <AnimatePresence>
                      {portfolioOpen && (
                        <motion.div
                          initial={{ opacity: 0, y: 6, scale: 0.98 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          exit={{ opacity: 0, y: 6, scale: 0.98 }}
                          transition={{ duration: 0.18, ease: "easeOut" }}
                          className={`
                            absolute
                            top-full
                            left-1/2
                            -translate-x-1/2
                            mt-4
                            before:absolute before:-top-4 before:left-0 before:h-4 before:w-full before:content-['']
                            w-[22rem]
                            flex
                            flex-col
                            gap-0.5
                            z-50
                            ${dropdownSurface}
                          `}
                        >
                          {portfolioLinks.map((item) => (
                            <NavLink
                              key={item.to}
                              to={item.to}
                              className="group/item rounded-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#8B4AFA]"
                            >
                              {({ isActive }) => (
                                <span
                                  className={`
                                    flex
                                    items-center
                                    gap-3.5
                                    px-3
                                    py-2.5
                                    rounded-xl
                                    transition-colors
                                    duration-200
                                    ${
                                      isActive
                                        ? "bg-violet-50"
                                        : "hover:bg-slate-50"
                                    }
                                  `}
                                >
                                {/* Icon tile */}
                                <span
                                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border transition-colors duration-200 ${
                                    isActive
                                      ? "border-violet-200 bg-white"
                                      : "border-slate-200 bg-slate-50 group-hover/item:border-violet-200 group-hover/item:bg-white"
                                  }`}
                                >
                              {item.logo ? (
                                <img
                                  src={item.logo}
                                  alt={item.name}
                                  className="h-6 w-6 object-contain"
                                />
                              ) : (
                                <item.icon className="h-5 w-5" style={{ color: item.color }} />
                              )}
                            </span>
                                  <span className="flex min-w-0 flex-col">
                                    <span
                                      className={`text-sm font-semibold leading-5 transition-colors duration-200 ${
                                        isActive
                                          ? "text-violet-700"
                                          : "text-slate-800 group-hover/item:text-violet-700"
                                      }`}
                                    >
                                      {item.name}
                                    </span>
                                    <span className="truncate text-xs leading-5 text-slate-500">
                                      {item.desc}
                                    </span>
                                  </span>
                                  {isActive && (
                                    <span className="ml-auto h-1.5 w-1.5 shrink-0 rounded-full bg-[#8B4AFA]" />
                                  )}
                                </span>
                                                            )}
                            </NavLink>
                          ))}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>

                  <div
                    className="relative shrink-0 group"
                    onMouseEnter={() => setProductsOpen(true)}
                    onMouseLeave={() => setProductsOpen(false)}
                    onFocus={() => setProductsOpen(true)}
                    onBlur={handleBlurClose(setProductsOpen)}
                    onKeyDown={(e) => e.key === "Escape" && setProductsOpen(false)}
                  >
                    <button
                    type="button"
                    className="flex items-center gap-1 whitespace-nowrap rounded-lg px-3 py-1.5 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4AFA]"
                    aria-haspopup="true"
                    aria-expanded={productsOpen}
                  >
                  <span className="whitespace-nowrap text-[14px] font-medium tracking-[-0.005em] text-slate-600 transition-colors duration-200 group-hover:text-violet-700">
                    Our Product
                  </span>
                      <FaChevronDown
                        size={9}
                        className={`transition-transform duration-200 ${
                          productsOpen
                            ? "rotate-180 text-[#8B4AFA]"
                            : "text-slate-400 group-hover:text-[#8B4AFA]"
                        }`}
                      />
                    </button>

                    <AnimatePresence>
                      {productsOpen && (
                        <motion.div
                          initial={{ opacity: 0, y: 6, scale: 0.98 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          exit={{ opacity: 0, y: 6, scale: 0.98 }}
                          transition={{ duration: 0.18, ease: "easeOut" }}
                         className={`absolute left-1/2 top-full z-50 mt-4 w-80 -translate-x-1/2 before:absolute before:-top-4 before:left-0 before:h-4 before:w-full before:content-[''] ${dropdownSurface}`}
                        >
                          {/* <p className="px-4 pb-2 pt-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-[#8B4AFA]">
                            Our Products
                          </p> */}
                          <a
                            href="https://mktextbiz.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group/item block rounded-xl px-3.5 py-3 transition-colors duration-200 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#8B4AFA]"
                          >
                            <span className="flex items-center justify-between gap-3 text-sm font-semibold text-slate-800 group-hover/item:text-violet-700">
                              MK TextBiz
                              <FaExternalLinkAlt className="h-2.5 w-2.5 text-slate-400 transition-colors duration-200 group-hover/item:text-[#8B4AFA]" />
                            </span>
                            <span className="mt-0.5 block text-xs leading-5 text-slate-500">
                              SMS &amp; MMS Marketing Platform
                            </span>
                          </a>

                           <a
                              href="https://agent.mkaitechnology.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="group/item block rounded-xl px-3.5 py-3 transition-colors duration-200 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#8B4AFA]"
                            >
                              <span className="flex items-center justify-between gap-3 text-sm font-semibold text-slate-800 group-hover/item:text-violet-700">
                                AI Agent Demos
                                <FaExternalLinkAlt className="h-2.5 w-2.5 text-slate-400 transition-colors duration-200 group-hover/item:text-[#8B4AFA]" />
                              </span>
                              <span className="mt-0.5 block text-xs leading-5 text-slate-500">
                                Try our AI agents live
                              </span>
                            </a>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>

                  <DesktopNavItem to="/about" label="About" />
                  {/* <DesktopNavItem to="/contact" label="Contact" /> */}

                <span className="mk-shine ml-4 xl:ml-14">
                  <BrandButton as={Link} to="/contact" navbar>
                    Get a Free Consultation
                  </BrandButton>
                </span>
                </nav>
              </div>
            </div>

             <motion.span
              aria-hidden="true"
              style={{ scaleX: progress }}
              className="pointer-events-none absolute bottom-0 left-5 right-5 h-[2px] origin-left rounded-full bg-gradient-to-r from-[#8B4AFA] via-violet-400 to-fuchsia-400"
            />
           </motion.div>
        </motion.div>
      )}

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {sidebarOpen && (
          <>
            {/* Background overlay */}
            <motion.div
              className="fixed inset-0 bg-slate-950/50 z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSidebarOpen(false)}
            />

            {/* Sidebar */}
           <motion.div
  id="mobile-sidebar"
  role="dialog"
  aria-modal="true"
  aria-label="Main menu"
  className="fixed top-0 left-0 w-[85%] max-w-sm h-full bg-white shadow-[0_0_0_1px_rgba(15,23,42,0.06),0_24px_48px_-12px_rgba(15,23,42,0.25)] z-50 flex flex-col"
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "tween", duration: 0.3, ease: "easeOut" }}
            >
              {/* Sidebar Header */}
              <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200/80">
                <Link to="/" onClick={() => setSidebarOpen(false)}>
                 <img
                    src="/website-logo1-309.webp"
                    alt="MK AI Technologies"
                    width="74"
                    height="40"
                    className="h-10 w-auto"
                  />
                </Link>
                <button
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-slate-200 text-slate-500 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900 active:bg-slate-100 transition-colors duration-200 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4AFA]"
                 onClick={() => setSidebarOpen(false)}
                  aria-label="Close menu"
                  autoFocus
                  >
                  <FaTimes size={14} />
                </button>
              </div>

              {/* Sidebar Links */}
              <nav aria-label="Mobile" className="flex-1 overflow-y-auto px-3 py-4">
                <NavLink
                  to="/"
                  onClick={() => setSidebarOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center px-3.5 py-3 rounded-xl text-[15px] font-medium transition-colors duration-150 ${
                      isActive
                        ? "bg-violet-50 text-[#8B4AFA] font-semibold"
                        : "text-slate-700 hover:bg-slate-50 hover:text-slate-900 active:bg-slate-100"
                    }`
                  }
                >
                  Home
                </NavLink>

                {/* Mobile Portfolio Accordion */}
                <div className="mt-1">
                  <button
                    className={`w-full flex items-center justify-between px-3.5 py-3 rounded-xl text-[15px] font-medium transition-colors duration-150 ${
                      isPortfolioActive
                        ? "bg-violet-50 text-[#8B4AFA] font-semibold"
                        : "text-slate-700 hover:bg-slate-50 hover:text-slate-900 active:bg-slate-100"
                    }`}
                    onClick={() => setMobilePortfolioOpen(!mobilePortfolioOpen)}
                    aria-expanded={mobilePortfolioOpen}
                  >
                    Portfolio
                    <motion.span
                      animate={{ rotate: mobilePortfolioOpen ? 180 : 0 }}
                      transition={{ duration: 0.2 }}
                      className="text-[10px] text-slate-400"
                    >
                      <FaChevronDown />
                    </motion.span>
                  </button>

                  <AnimatePresence initial={false}>
                    {mobilePortfolioOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25, ease: "easeInOut" }}
                        className="overflow-hidden"
                      >
                        <div className="pl-3 pr-1 py-1 flex flex-col border-l border-slate-200 ml-5 mt-1 mb-1">
                          {portfolioLinks.map((item) => (
                            <NavLink
                              key={item.to}
                              to={item.to}
                              onClick={() => setSidebarOpen(false)}
                              className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors duration-150 ${
                                  isActive
                                    ? "text-[#8B4AFA] font-semibold bg-violet-50"
                                    : "text-slate-600 hover:text-slate-900 hover:bg-slate-50 active:bg-slate-100"
                                }`
                              }
                              >
                              {item.logo ? (
                              <img
                                src={item.logo}
                                alt={item.name}
                                className="h-3.5 w-3.5 shrink-0 scale-[1.6] object-contain"
                              />
                            ) : (
                                <item.icon className="h-3.5 w-3.5 shrink-0" style={{ color: item.color }} />
                              )}
                              {item.name}
                              </NavLink>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                <div className="mt-1">
                  <button
                    type="button"
                    className="flex w-full items-center justify-between rounded-xl px-3.5 py-3 text-[15px] font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-50 hover:text-slate-900 active:bg-slate-100"
                    onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                    aria-expanded={mobileProductsOpen}
                  >
                    Our Product
                    <motion.span
                      animate={{ rotate: mobileProductsOpen ? 180 : 0 }}
                      transition={{ duration: 0.2 }}
                      className="text-[10px] text-slate-400"
                    >
                      <FaChevronDown />
                    </motion.span>
                  </button>

                  <AnimatePresence initial={false}>
                    {mobileProductsOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25, ease: "easeInOut" }}
                        className="overflow-hidden"
                      >
                        <div className="ml-5 mt-1 flex flex-col border-l border-slate-200 py-1 pl-3 pr-1">
                          <a
                            href="https://mktextbiz.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => setSidebarOpen(false)}
                            className="rounded-lg px-3 py-2.5 text-sm transition-colors duration-150 hover:bg-slate-50 active:bg-slate-100"
                          >
                            <span className="flex items-center gap-2 font-semibold text-slate-700">
                              MK TextBiz <FaExternalLinkAlt className="h-2.5 w-2.5 text-[#8B4AFA]" />
                            </span>
                            <span className="mt-0.5 block text-xs leading-5 text-slate-500">
                              SMS &amp; MMS Marketing Platform
                            </span>
                          </a>
                          <a
                            href="https://agent.mkaitechnology.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => setSidebarOpen(false)}
                            className="rounded-lg px-3 py-2.5 text-sm transition-colors duration-150 hover:bg-slate-50 active:bg-slate-100"
                          >
                            <span className="flex items-center gap-2 font-semibold text-slate-700">
                              AI Agent Demos <FaExternalLinkAlt className="h-2.5 w-2.5 text-[#8B4AFA]" />
                            </span>
                            <span className="mt-0.5 block text-xs leading-5 text-slate-500">
                              Try our AI agents live
                            </span>
                          </a>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                <NavLink
                  to="/about"
                  onClick={() => setSidebarOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center px-3.5 py-3 mt-1 rounded-xl text-[15px] font-medium transition-colors duration-150 ${
                      isActive
                        ? "bg-violet-50 text-[#8B4AFA] font-semibold"
                        : "text-slate-700 hover:bg-slate-50 hover:text-slate-900 active:bg-slate-100"
                    }`
                  }
                >
                  About
                </NavLink>

                {/* <NavLink
                  to="/contact"
                  onClick={() => setSidebarOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center px-3 py-3 mt-1 rounded-xl text-[15px] font-medium transition-colors duration-150 ${
                      isActive
                        ? "bg-violet-50 text-[#8B4AFA] font-semibold"
                        : "text-slate-700 hover:bg-slate-50 hover:text-[#8B4AFA] active:bg-slate-100"
                    }`
                  }
                >
                  Contact
                </NavLink> */}
              </nav>

              {/* Sidebar footer: CTA stays pinned at the bottom so it's always reachable */}
              <div className="border-t border-slate-200/80 px-5 pb-6 pt-4">
               <BrandButton
                as={Link}
                to="/contact"
                onClick={() => setSidebarOpen(false)}
                navbar
                className="mk-cta-button--full"
              >
                Get a Free Consultation
              </BrandButton>
              </div>

            </motion.div>
          </>
        )}
      </AnimatePresence>
    </MotionConfig>
  );
};

export default AnimatedNavbar;
